import { PublicClientApplication, Configuration, BrowserAuthOptions, LogLevel } from '@azure/msal-browser';

// MSAL Configuration for user authentication
// This client ID is used for OSDU API access with user delegation
//
// `navigateToLoginRequestUrl` was dropped from the public `BrowserAuthOptions`
// type in msal-browser v5 but is still honored at runtime (RedirectClient reads
// `options.navigateToLoginRequestUrl ?? true`). We keep it via a typed
// intersection so the app still avoids the login-page flash on redirect.
const authOptions: BrowserAuthOptions & { navigateToLoginRequestUrl?: boolean } = {
  clientId: "478bece1-ebbc-4d21-b5b8-b7c9d948a53e",
  authority: "https://login.microsoftonline.com/3aa4a235-b6e2-48d5-9195-7fcf05b459b0",
  redirectUri: window.location.origin + "/",
  postLogoutRedirectUri: window.location.origin + "/login",
  // After processing the redirect, stay on redirectUri ('/') instead of
  // navigating back to the page where loginRedirect() was called ('/login').
  // This prevents a login-page flash before landing on home.
  navigateToLoginRequestUrl: false,
};

export const msalConfig: Configuration = {
  auth: authOptions,
  cache: {
    cacheLocation: 'sessionStorage',
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

export const loginRequest = {
  scopes: ["openid", "profile", "email"]
};

// OSDU token request - scopes are environment-specific
export const getOsduTokenRequest = (scope: string) => ({
  scopes: [scope]
});

// Graph API token request for delegated permissions (Application.Read.All)
export const graphTokenRequest = {
  scopes: [
    "https://graph.microsoft.com/Application.Read.All",
  ]
};

export const msalInstance = new PublicClientApplication(msalConfig);

// OSDU Configuration
export const OSDU_CONFIG = {
  baseURL: import.meta.env.VITE_OSDU_BASE_URL || '', // Use proxy server
  dataPartitionId: import.meta.env.VITE_DATA_PARTITION_ID || 'data',
}; 